// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"7a5f07bb","726":"a8a43eeb","785":"de5b5e84"}[chunkId] + ".chunk.js";
};